/* Theme-driven page frame. Colors come from Astryx neutral-theme tokens, so
   this must live inside an Astryx <Theme> scope (unlike PageContainer, which
   uses the app's own --color-background / --color-foreground). */
.frame {
  min-height: 100vh;
  background: var(--color-background-body);
  color: var(--color-text-primary);
  text-align: left;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
